import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import * as actions from './checkin-common.actions';
import { CheckinCommonState } from './checkin-common.state';

/**
 * checkinCommon initial state
 */
export const checkinCommonInitialState: CheckinCommonState = {};

/**
 * List of basic actions for CheckinCommon Store
 */
export const checkinCommonReducerFeatures: ReducerTypes<CheckinCommonState, ActionCreator[]>[] = [
  on(actions.setCheckinCommon, (_state, payload) => ({ ...payload })),

  on(actions.updateCheckinCommon, (state, payload) => {
    return { ...state, ...payload };
  }),

  on(actions.resetCheckinCommon, () => checkinCommonInitialState),
];

/**
 * CheckinCommon Store reducer
 */
export const checkinCommonReducer = createReducer(checkinCommonInitialState, ...checkinCommonReducerFeatures);
